export default __webpack_public_path__ + "static/media/sales.6e0eff69.svg";